import { render, staticRenderFns } from "./BetLogo.vue?vue&type=template&id=407a63f9&scoped=true&"
import script from "./BetLogo.vue?vue&type=script&lang=js&"
export * from "./BetLogo.vue?vue&type=script&lang=js&"
import style0 from "./BetLogo.vue?vue&type=style&index=0&id=407a63f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407a63f9",
  null
  
)

export default component.exports